import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AdminLayout from "../../LayoutWrapper/AdminLayout";
import CookieOutlinedIcon from "@mui/icons-material/CookieOutlined";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { COOKIES_INTRO, COOKIE_TYPES, COOKIES_SECTIONS } from "./content";
import "../../CSS/CookiesPolicy/modern.css";

const CookiesPolicy = () => {
  const { t } = useTranslation();
  const [activeSection, setActiveSection] = useState("");

  useEffect(() => {
    const handleScroll = () => {
      const scrollPos = window.scrollY + 120;
      let current = "";
      COOKIES_SECTIONS.forEach((section) => {
        const el = document.getElementById(section.id);
        if (el && el.offsetTop <= scrollPos) {
          current = section.id;
        }
      });
      setActiveSection(current);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <AdminLayout>
      <div className="cookies-page">
        <section className="cookies-hero">
          <div className="cookies-hero__inner">
            <span className="cookies-hero__badge">
              <CookieOutlinedIcon sx={{ fontSize: 18 }} />
              Legal
            </span>
            <h1 className="cookies-hero__title">{t("page_title_cookies_policy")}</h1>
            <p className="cookies-hero__meta">Last updated: May 2026</p>
          </div>
        </section>

        <section className="cookies-body">
          <div className="cookies-body__inner">
            <nav className="cookies-toc" aria-label="Table of contents">
              <p className="cookies-toc__title">On this page</p>
              <ul className="cookies-toc__list">
                {COOKIES_SECTIONS.map((section) => (
                  <li key={section.id}>
                    <a
                      href={`#${section.id}`}
                      className={`cookies-toc__link${
                        activeSection === section.id ? " cookies-toc__link--active" : ""
                      }`}
                      onClick={(e) => {
                        e.preventDefault();
                        scrollToSection(section.id);
                      }}
                    >
                      {section.title}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>

            <div className="cookies-content">
              <p className="cookies-intro">{COOKIES_INTRO}</p>

              {COOKIES_SECTIONS.map((section) => (
                <article key={section.id} id={section.id} className="cookies-section">
                  <h2 className="cookies-section__title">{section.title}</h2>
                  {section.paragraphs.map((paragraph) => (
                    <p key={paragraph.slice(0, 40)}>
                      {paragraph.includes("support@comfort-trip.com") ? (
                        <>
                          If you have questions about our Cookies Policy, please contact us at{" "}
                          <span className="cookies-section__email">support@comfort-trip.com</span>.
                        </>
                      ) : (
                        paragraph
                      )}
                    </p>
                  ))}
                  {section.showCookieTypes && (
                    <div className="cookies-types-grid">
                      {COOKIE_TYPES.map((type) => (
                        <div key={type.title} className="cookies-type-card">
                          <h3 className="cookies-type-card__title">{type.title}</h3>
                          <p className="cookies-type-card__text">{type.description}</p>
                        </div>
                      ))}
                    </div>
                  )}
                  {section.listItems && (
                    <ul>
                      {section.listItems.map((item) => (
                        <li key={item}>{item}</li>
                      ))}
                    </ul>
                  )}
                </article>
              ))}

              <div className="cookies-cta">
                <h3 className="cookies-cta__title">Related policies</h3>
                <p className="cookies-cta__text">
                  Learn more about how we handle your data and terms of service.
                </p>
                <div className="cookies-cta__links">
                  <Link to="/privacypolicy" className="cookies-cta__link">
                    Privacy Policy
                    <ArrowForwardIcon fontSize="small" />
                  </Link>
                  <Link to="/contact" className="cookies-cta__link cookies-cta__link--outline">
                    Contact us
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </AdminLayout>
  );
};

export default CookiesPolicy;
